import { Branding } from './Branding';
import { IntroStep } from './IntroStep';
import UnavailableMarket from './img/unavailable_market.png';

import styles from './UnsupportedMarketPage.module.css';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- child component rendered inside tracked UnsupportedMarketRoute
export const UnsupportedMarketPage = ({
  onNotifyMe,
}: {
  onNotifyMe: () => void;
}) => (
  <div
    className={styles.root}
    data-testid="unsupported-market"
    data-track-id="region.unsupported-market"
    data-track-impression
  >
    <Branding />
    <IntroStep
      title="We're not in your country just yet, but don't worry!"
      description="We are working on expanding Confidence to more countries. Click 'Notify me' so you can be the first to know when we make it to your country."
      buttonLabel="Notify me"
      img={UnavailableMarket}
      onNext={onNotifyMe}
    />
  </div>
);
